<template>
  <v-dialog v-model="openMode" max-width="500px" content-class="delete-dialog">
    <v-card class="delete-card">
      <div class="delete-header">
        <v-icon size="64" color="error" class="delete-icon">mdi-alert-circle</v-icon>
        <h2 class="delete-title">{{ isBulkDelete ? 'מחיקת אנשי קשר' : 'מחיקת איש קשר' }}</h2>
        <p class="delete-message">
          {{ isBulkDelete ? `האם אתה בטוח שברצונך למחוק ${items.length} אנשי קשר?` : 'האם אתה בטוח שברצונך למחוק את איש הקשר?' }}
        </p>

        <p class="delete-details" v-if="!isBulkDelete && item && item.name">
          <strong>{{ item.name }}</strong>
          <span v-if="item.phone"> ({{ item.phone }})</span>
        </p>

        <!-- Bulk items summary -->
        <div class="bulk-details" v-if="isBulkDelete && items && items.length > 0">
          <div class="bulk-items-list" v-if="items.length <= 5">
            <div class="bulk-item" v-for="(bulkItem, index) in items" :key="index">
              <v-icon x-small color="error">mdi-account</v-icon>
              <span>{{ bulkItem.name || 'ללא שם' }}<span v-if="bulkItem.phone"> ({{ bulkItem.phone }})</span></span>
            </div>
          </div>
          <p class="preview-text" v-else>
            כולל: {{ items.slice(0, 3).map(i => i.name || 'ללא שם').join(', ') }} ועוד {{ items.length - 3 }}...
          </p>
        </div>
      </div>

      <v-divider class="mx-4 my-3"></v-divider>

      <!-- Loading Progress -->
      <v-slide-y-transition>
        <div class="progress-container" v-if="progressShow">
          <v-progress-linear
            indeterminate
            color="error"
            height="4"
            class="mb-3"
          ></v-progress-linear>
          <div class="progress-text">{{ isBulkDelete ? 'מוחק...' : 'מוחק...' }}</div>
        </div>
      </v-slide-y-transition>

      <v-card-actions class="delete-actions">
        <v-btn
          text
          color="grey darken-1"
          @click="closeDelete"
          :disabled="progressShow"
          class="cancel-btn"
        >
          ביטול
        </v-btn>

        <v-btn
          color="error"
          :loading="progressShow"
          :disabled="progressShow"
          @click="actionConfirmed"
          class="delete-btn"
        >
          <v-icon left>mdi-delete</v-icon>
          מחק
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar 
      v-model="snackbar" 
      :snacbarText="snacbarText" 
      :snackbarColorBt="snackbarColorBt"
    ></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    item: Object,
    items: { type: Array, default: () => [] },
    isBulkDelete: { type: Boolean, default: false },
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),

  methods: {
    actionConfirmed() {
      if (this.isBulkDelete) {
        this.deleteMultipleItems();
      } else {
        this.deleteItem();
      }
    },

    async deleteItem() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ phone: this.item.phone, id: this.item._id });

        let api = process.env.VUE_APP_BASE_URL + "/subscribes/delete_subscribe";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", itemsJSON, token));
        
        if (res.status >= 400) {
          this.$emit("itemDeleted", "", "תקלה במחיקת איש קשר", "red");
        } else if (res.status === 200) {
          this.$emit("itemDeleted", this.item._id, "איש הקשר נמחק בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.$emit("itemDeleted", "", "תקלה במחיקת איש קשר", "red");
      } finally {
        this.progressShow = false;
      }
    },

    async deleteMultipleItems() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const ids = this.items.map(item => item._id);
        const itemsJSON = JSON.stringify({ ids });

        let api = process.env.VUE_APP_BASE_URL + "/subscribes/delete_multiple_subscribes";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", itemsJSON, token));

        if (res.status >= 400) {
          this.$emit("itemsDeleted", [], "תקלה במחיקת אנשי קשר", "red");
        } else if (res.status === 200) {
          this.$emit("itemsDeleted", ids, `${ids.length} אנשי קשר נמחקו בהצלחה!`, "green");
          this.openMode = false;
        }
      } catch (error) {
        this.$emit("itemsDeleted", [], "תקלה במחיקת אנשי קשר", "red");
      } finally {
        this.progressShow = false;
      }
    },
    
    closeDelete() {
      this.openMode = false;
    }
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
}
</script>

<style scoped>
.delete-dialog {
  border-radius: 16px;
}

.delete-card {
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(to bottom, #ffffff, #fff5f5);
}

.delete-header {
  padding: 32px 24px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.delete-icon {
  margin-bottom: 16px;
  opacity: 0.9;
}

.delete-title {
  color: #e11d48;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
}

.delete-message {
  color: #64748b;
  font-size: 16px;
  margin-bottom: 8px;
}

.delete-details {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 8px 16px;
  border-radius: 8px;
  margin-top: 8px;
  font-size: 16px;
  max-width: 100%;
  word-break: break-word;
}

.bulk-details {
  width: 100%;
  margin-top: 8px;
}

.bulk-items-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
  padding: 4px;
}

.bulk-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background-color: #fee2e2;
  color: #b91c1c;
  border-radius: 8px;
  font-size: 14px;
}

.preview-text {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin: 0;
}

.progress-container {
  padding: 16px 24px;
  text-align: center;
}

.progress-text {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.delete-actions {
  padding: 16px 24px 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.cancel-btn, .delete-btn {
  min-width: 120px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .delete-actions {
    flex-direction: column-reverse;
  }
  
  .cancel-btn, .delete-btn {
    width: 100%;
  }
}
</style>